import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import FormItem from '../../../components/form/FormItem'
import { MdTitle } from 'react-icons/md'
import { BiX } from 'react-icons/bi'
import { Button, Form } from 'reactstrap'
import { ToSeoUrl } from '../../../components/general/SeoUrl'
import DragDropFiles from '../../../components/form/DragDropFiles'
import { fetchShowcaseGet } from '../../../redux/slices/showcaseGetSlice'
import { fetchShowcaseCreate } from '../../../redux/slices/showcaseCreateSlice'
import { fetchShowcaseUpdate } from '../../../redux/slices/showcaseUpdateSlice'

const CrudShowcase = ({ showMenu, setShowMenu, setChanged, setSelectedItem, lang, id, selectedItem, t }) => {
    const [formData, setFormData] = useState({ files: [], productId: id, sort: 0 })
    const dispatch = useDispatch()

    const getData = async () => {
        if (selectedItem !== 0) {
            var data = await dispatch(fetchShowcaseGet({ id: selectedItem }))

            if (data.payload) {
                setFormData({
                    files: data.payload?.files,
                    titletr: data.payload?.title["tr"],
                    titleen: data.payload?.title["en"],
                    descriptiontr: data.payload?.description["tr"],
                    descriptionen: data.payload?.description["en"],
                    slugtr: data.payload?.slug["tr"],
                    slugen: data.payload?.slug["en"],
                    productID: id,
                    sort: data.payload?.sort || 0,
                })
            }
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const title = { "tr": formData.titletr, "en": formData.titleen }
        const slug = { "tr": ToSeoUrl(formData.titletr), "en": ToSeoUrl(formData.titleen) }
        const description = { "tr": formData.descriptiontr, "en": formData.descriptionen }
        const content = {}

        const filesToKeep = formData.files
            .filter(file => typeof file === 'string' || !file.file)
            .map(file => typeof file === 'string' ? file : file.preview);

        const newFiles = formData.files.filter(file => file.file);

        await dispatch(
            selectedItem === 0 ?
                fetchShowcaseCreate({ file: newFiles, title: title, slug: slug, description: description, content: content, productId: id, sort: formData.sort }) :
                fetchShowcaseUpdate({ id: selectedItem, file: newFiles, title: title, slug: slug, description: description, content: content, productId: id, sort: formData.sort, filesToKeep: filesToKeep })
        )
        setChanged(true)
        setFormData({ files: [], titletr: "", titleen: "", slugtr: "", slugen: "", descriptiontr: "", descriptionen: "" })
        getData()
        setShowMenu(false)
    }

    const closeModal = () => {
        setFormData({ files: [] })
        setShowMenu(false)
        setSelectedItem(0)
    }

    useEffect(() => { getData() }, [dispatch, selectedItem, id, lang])

    return (
        <div className={showMenu ? 'right-popup' : 'd-none'}>
            <div className='right-popup-close' onClick={closeModal}><BiX size={24} /></div>
            <div className='right-popup-menu'>
                <div className='mb-3 text-center'><h5>{t(selectedItem === 0 ? "add_showcase" : "edit_showcase")}</h5></div>
                <Form onSubmit={handleSubmit}>
                    <DragDropFiles
                        formData={formData}
                        setFormData={setFormData}
                        selectedItem={selectedItem}
                        title={t("images")}
                    />

                    <FormItem
                        id={`titletr`}
                        name={`titletr`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("title")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='titletr'
                    />
                    <FormItem
                        id={`titleen`}
                        name={`titleen`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("title")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='titleen'
                    />
                    <FormItem
                        id={`descriptiontr`}
                        name={`descriptiontr`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("description")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='descriptiontr'
                    />
                    <FormItem
                        id={`descriptionen`}
                        name={`descriptionen`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("description")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='descriptionen'
                    />

                    <div className='d-flex justify-content-end mt-4 w-100'>
                        <Button type='submit' color={selectedItem === 0 ? 'primary' : 'warning'} className="text-white">
                            {t(selectedItem === 0 ? "add" : "edit")}
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default CrudShowcase